interface CardOption<T extends string> {
  value: T
  label: string
  description: string
  icon: React.ReactNode
}

interface CardSelectorProps<T extends string> {
  options: CardOption<T>[]
  value: T | undefined
  onChange: (val: T) => void
  error?: string
}

export function CardSelector<T extends string>({
  options,
  value,
  onChange,
  error,
}: CardSelectorProps<T>) {
  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {options.map((option) => {
          const isSelected = value === option.value
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              className={`flex items-start gap-3 p-4 rounded-lg border-2 text-left transition-all ${
                isSelected
                  ? 'border-primary-500 bg-primary-50 ring-1 ring-primary-500'
                  : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
              }`}
            >
              <div
                className={`flex-shrink-0 mt-0.5 ${
                  isSelected ? 'text-primary-600' : 'text-gray-400'
                }`}
              >
                {option.icon}
              </div>
              <div>
                <p className={`font-medium text-sm ${isSelected ? 'text-primary-700' : 'text-gray-700'}`}>
                  {option.label}
                </p>
                <p className="text-xs text-gray-500 mt-0.5">{option.description}</p>
              </div>
            </button>
          )
        })}
      </div>
      {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
    </div>
  )
}

export type { CardOption }
